import AsyncSelect, { Option, type AsyncSelectBaseProps } from "./AsyncSelect";
import { TaxOfficeService } from "@/services/taxOffice";
import { useTranslation } from "react-i18next";
import { forwardRef, useCallback } from "react";
import appConfiguration from "./cfg/AppCfg";
import { FilterType } from "@/lib/filters";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { useCreateDataTableOptions } from "./data-table/hooks/useCreateDataTableOptions";
import { ReadTaxOffice } from "@/types/taxOffice";

interface TaxOfficeSelectProps extends AsyncSelectBaseProps {
  className?: string;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, TaxOfficeSelectProps>(
  function TaxOfficeSelect({ defaultItem, ...props }, ref) {
    const { t } = useTranslation();
    const name = "taxOfficeSelect";
    const options = useCreateDataTableOptions<ReadTaxOffice>(name);
    const queryKey = useDynamicQueryParams<ReadTaxOffice>(name, options);

    const onFilter = useCallback(
      (filterValue: string) => {
        options.setFilterValue("name", {
          value: filterValue,
          filter: FilterType.IncludesString,
        });
      },
      [options],
    );

    return (
      <AsyncSelect
        queryKey={queryKey}
        queryFn={() =>
          TaxOfficeService.getList({
            filters: options.filters,
            limit: appConfiguration.selectComponentsPaginationLimit,
          })
        }
        enableFilter={true}
        onFilter={onFilter}
        placeholder={t("taxOfficeSelect.placeholder")}
        loadingLabel={t("taxOfficeSelect.loading")}
        searchLabel={t("taxOfficeSelect.search")}
        noResultsLabel={t("taxOfficeSelect.noResults")}
        {...props}
        ref={ref}
        className="w-full"
        defaultItem={defaultItem}
      />
    );
  },
);
